import { useState, type ReactElement } from 'react';

import type { CloudApi } from '../api/client';
import { errorMessage } from '../api/client';
import { ErrorMessage } from './Status';

interface InvitationAcceptProps {
  readonly api: CloudApi;
  readonly token: string;
  readonly onAccepted: (projectId: string) => void;
  readonly onBack: () => void;
}

export function InvitationAccept({ api, token, onAccepted, onBack }: InvitationAcceptProps): ReactElement {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const accept = async (): Promise<void> => {
    setBusy(true);
    setError(null);
    try {
      const result = await api.acceptInvitation(token);
      onAccepted(result.projectId);
    } catch (reason) {
      setError(errorMessage(reason));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="centered-card">
      <p className="eyebrow">Project invitation</p>
      <h1>接受專案邀請</h1>
      <p>系統會確認目前登入帳號的已驗證電子郵件與邀請相符。</p>
      {error !== null && <ErrorMessage message={error} />}
      <div className="card-actions">
        <button type="button" disabled={busy} onClick={() => void accept()}>{busy ? '接受中…' : '接受邀請'}</button>
        <button type="button" className="secondary" disabled={busy} onClick={onBack}>返回專案</button>
      </div>
    </main>
  );
}
